import React from 'react';
import Dr from '../images/personnel/400md-300x300-1.png'

const ManagingDirectorMessage = () => {
  return (
    <></>
  );
};

export default ManagingDirectorMessage;
